
import { useDispatch } from 'react-redux';
import { setInitToken, setTokenInitRequestData } from '../actionCreators/initToken';

export function ResetInitToken() {
    const dispatch = useDispatch();

    dispatch(setInitToken(null));
    dispatch(setTokenInitRequestData({}));
}